export default __webpack_public_path__ + "static/es-5d6a2e339ec6c7c6acae586d3a87d9b4.svg";